module.exports = __webpack_public_path__ + "zvetseni-rtu-permalip_3_after_tn.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures_tn/plasticka-chirurgie/zvetseni-rtu-permalip_3_after_tn.jpg
// module id = 1845
// module chunks = 0